<template>
  <v-section class="c-section--episodes">
    <ui-tile
      v-for="product in $section.products"
      :key="product.id"
      :product="product"
      :layout="TileLayout.EPISODE"
    ></ui-tile>
    <template #headerLeft>
      <slot name="headerLeft"></slot>
    </template>
    <template #headerRight>
      <slot name="headerRight"></slot>
    </template>
  </v-section>
</template>
<script>
  import { TileLayout } from '@/shared/enums';
  import { VSection } from '@/index/shared/components';
  import UiTile from '../../tile/index.vue';

  export default {
    components: {
      UiTile,
      VSection,
    },
    enums: {
      TileLayout,
    },
    inject: ['$section'],
  };
</script>
